import { css } from "@/../styled-system/css";

import AvatarSkeleton from "./AvatarSkeleton";
import Skeleton from "../ui/Skeleton";

function ProfileFooterSkeleton() {
  return (
    <>
      <AvatarSkeleton size="md" />
      <div className={css({ width: "100%", minWidth: "0" })}>
        <Skeleton css={{ width: "100%", height: "1.25rem", mb: "0.5" }} />
        <Skeleton css={{ width: "100%", height: "1.25rem" }} />
      </div>
      <Skeleton
        css={{ width: "37px", height: "37px", rounded: "lg", flexShrink: "0" }}
      />
    </>
  );
}

export default ProfileFooterSkeleton;
